import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import React from 'react'

const LegendInfo = (props) => {
  return (
    <CModal
      alignment="center"
      scrollable
      visible={props.infoPageModal}
      onClose={() => props.setInfoPageModal(false)}
    >
      <CModalHeader>
        <CModalTitle>Information</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>
          <strong>GO</strong>: Goal{' '}
        </p>
        <p>
          <strong>GKS</strong>:GK Saves
        </p>
        <p>
          <strong>OG</strong>: Own Goal
        </p>
        <p>
          <strong>AST</strong>: Assist
        </p>
        <p>
          <strong>PI</strong>: Passes Intercepted
        </p>
        <p>
          <strong>TW</strong>: Tackles Won
        </p>
        <p>
          <strong>PS</strong>: Penalty Saves
        </p>
        <p>
          <strong>PM</strong>: Penalty Miss
        </p>
        <p>
          <strong>GCD</strong>: Green Card
        </p>
        <p>
          <strong>YCD</strong>: Yellow Card
        </p>
        <p>
          <strong>RCD</strong>: Red Card
        </p>
        <p>
          <strong>CST</strong>: Clean Sheet
        </p>
        <p>
          <strong>P 60</strong>: Played 60mins
        </p>
        <p>
          <strong>P60+ </strong>: Played 60+mins
        </p>
        <p>
          <strong>FP</strong>: Fantasy Points
        </p>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={() => props.setInfoPageModal(false)}>
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default LegendInfo
